import { IonButton, IonButtons, IonText } from '@ionic/react';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { PaymentSelectorEnum } from '@/redux/tpv/tpvPayment';

import ErrorCardSVG from '../../assets/imgs/errorCard/ErrorCardSVG';
import styles from './ErrorCard.module.scss';

interface ErrorCardProps {
  paymentMethod?: PaymentSelectorEnum | null;
  buttonClick: (data: boolean) => void;
}

export default function ErrorCard({
  paymentMethod,
  buttonClick,
}: ErrorCardProps) {
  const paymentCards = useSelector((state: any) => state.paymentCard.paymentCards);

  const returnToPayment = () => {
    buttonClick(true);
  };

  useEffect(() => {
  }, []);

  return (
    <div className={styles.cardInfo}>
      <ErrorCardSVG />
      <div className={styles.errorCardTextWrapper}>
        <IonText className={styles.cardInfoText}>¡Ups!</IonText>
        {paymentMethod === PaymentSelectorEnum.EXPRESS ? (
          <IonText className={styles.cardInfoMessage}>
            No se ha podido reutilizar tu tarjeta.
          </IonText>
        ) : (
          <IonText className={styles.cardInfoMessage}>
            Ha ocurrido un problema y no hemos podido ejecutar el pago. Prueba
            con una forma de pago distinta.
          </IonText>
        )}
      </div>
      <div className={styles.cardErrorButton}>
        <IonButtons className={styles.nextBtnWrapper}>
          <IonButton className="nextButton" id="end-close-button" onClick={returnToPayment}>
            {paymentCards?.length === 0 ? 'Elegir otra tarjeta' : 'Volver'}
          </IonButton>
        </IonButtons>
      </div>
    </div>
  );
}
